import React from 'react';
import { TimePicker as AntTimePicker } from 'antd';
import cn from 'classnames';
import { timeFormat } from '../../../packages/dateTime';
import styles from './index.module.scss';

const TimePicker = ({ className, ...props }) => {
  return (
    <AntTimePicker
      {...props}
      format={timeFormat}
      className={cn(styles.root, className)}
      popupClassName={styles.popup}
    />
  );
};

export default TimePicker;
